import { __ } from '@wordpress/i18n';
import Hero from '../../UI/hero';
import { Date } from '../../UI/form-controls';
import { createRoot } from 'react-dom/client';

const RenderCoponent = () => {
    return (
        <Date placeholder={__( 'Önskat incheckningsdatum', 'dalslandskanal-custom-blocks' )} hidePlaceholder={true} />
    );
}

const renderBlock = () => {
    const dateElement = document.getElementById('date-control');
    const root = createRoot(dateElement);
    root.render(<RenderCoponent />);
};

renderBlock();